export enum LanguageCodes {
  EN = 'en',
  JP = 'jp'
}
